import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CodedValue} from "../../_models/models";

@Component({
  selector: 'app-map-edition-select-overlay',
  templateUrl: './map-edition-select-overlay.component.html',
  styleUrls: ['./map-edition-select-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapEditionSelectOverlayComponent implements OnInit, OnChanges {

  @Input() label!: string;
  @Input() values!: number[];
  @Input() codedValues!: CodedValue[];
  @Input() multiple = false;
  @Input() required = false;
  @Output() done = new EventEmitter<CodedValue[] | undefined>();

  public form!: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group(
      {code: [this.values, Validators.required]}
    );
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.values && changes.values.currentValue) {
      const types: CodedValue[] = [];
      this.codedValues.forEach(x => {
        if (changes.values.currentValue.indexOf(x.code) > -1) {
          types.push(x);
        }
      });
      this.form.get('code')?.setValue(this.multiple ? types : types[0]);
    }
  }

  compare(a: CodedValue, b: CodedValue): boolean {
    return a != null && b != null && a.code === b.code;
  }

  validate(): void {
    if (this.form.valid) {
      const result = this.form.get('code')?.value;
      this.done.emit(Array.isArray(result) ? result : [result]);
    }
  }
}
